import React, { Suspense } from 'react';
import styled from 'styled-components';

import { LoadingIndicator } from '@/components/application/loading-indicator/loading-indicator';
import { Sidebar } from '../layout/sidebar';

import MainRouter from './mainRouter';
import { Content } from '../layout';

const PageContainer = styled.div`
  display: flex;
  flex-grow: 1;
  min-height: 100% !important;
  max-height: 100% !important;
  position: relative;
  flex-direction: column;
  overflow: hidden;
  z-index: 1;

  @media screen and (min-width: 992px) {
    flex-direction: row;
  }
`;

export { createRouteMap } from './route-config';

// Mirrors HaulerSuspenseFallback in src/components/hauler/index.tsx — the
// citizen sections are lazy chunks (see ./route-config.tsx).
const MainSuspenseFallback = () => (
  <div className="wh-ui flex h-full w-full items-center justify-center">
    <LoadingIndicator type="line-simple" size="md" />
  </div>
);

const Main = () => {
  return (
    <PageContainer>
      <div style={{ flexShrink: 0 }}>
        <Sidebar />
      </div>
      <Content>
        <Suspense fallback={<MainSuspenseFallback />}>
          <MainRouter />
        </Suspense>
      </Content>
    </PageContainer>
  );
};

export default Main;
